<svg width="34" height="40" viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <path d="M30.357 17.5h-1.821v-5.625C28.536 5.328 23.36 0 17 0 10.64 0 5.464 5.328 5.464 11.875V17.5H3.643C1.632 17.5 0 19.18 0 21.25v15C0 38.32 1.632 40 3.643 40h26.714C32.368 40 34 38.32 34 36.25v-15c0-2.07-1.632-3.75-3.643-3.75zm-7.893 0H11.536v-5.625c0-3.102 2.451-5.625 5.464-5.625 3.013 0 5.464 2.523 5.464 5.625V17.5z" id="h1rd0ppu5a"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <mask id="yyxpz5x52b" fill="currentColor">
            <use xlink:href="#h1rd0ppu5a"/>
        </mask>
        <use fill="currentColor" fill-rule="nonzero" xlink:href="#h1rd0ppu5a"/>
        <g mask="url(#yyxpz5x52b)" fill="currentColor">
            <path d="M-13-10h60v60h-60z"/>
        </g>
    </g>
</svg>
